// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tL3Xi","badges":"styles_badges__3rE5G"};